import React from "react";
import SectorCRUDTable from "@/components/SectorCRUDTable";
import { PawPrint } from "lucide-react";

const STATUS = { en_pension: "En pension", parti: "Parti", reserve: "Réservé" };
const COLOR = { en_pension: "#059669", parti: "#868E96", reserve: "#D97706" };
const ESPECES = { chien: "Chien", chat: "Chat", nac: "NAC", autre: "Autre" };

export default function ChefPensionnaires() {
  return (
    <SectorCRUDTable
      endpoint="/chef/secteur/pensionnaires"
      eyebrow="Garde animaux · Pensionnaires"
      title="Pensionnaires"
      sub="Suivez les animaux confiés, dates et soins."
      testidPrefix="pensionnaire"
      allowEdit
      defaultRow={() => ({ nom_animal: "", espece: "chien", race: "", proprietaire_nom: "", proprietaire_telephone: "", date_arrivee: new Date().toISOString().slice(0, 10), date_depart_prevue: new Date().toISOString().slice(0, 10), prix_jour: 0, regime_alimentaire: "", traitements: "", status: "en_pension", notes: "" })}
      columns={[
        { key: "nom_animal", label: "Nom" },
        { key: "espece", label: "Espèce", width: "100px", render: (v) => ESPECES[v] || v },
        { key: "race", label: "Race", width: "120px" },
        { key: "proprietaire_nom", label: "Propriétaire", width: "180px" },
        { key: "date_arrivee", label: "Arrivée", width: "110px", render: (v) => v ? new Date(v).toLocaleDateString("fr-FR") : "—" },
        { key: "date_depart_prevue", label: "Sortie", width: "110px", render: (v) => v ? new Date(v).toLocaleDateString("fr-FR") : "—" },
        { key: "status", label: "Statut", width: "120px", render: (v) => <span className="text-[9px] uppercase font-bold px-2 py-0.5" style={{ color: COLOR[v], background: `${COLOR[v]}15` }}>{STATUS[v] || v}</span> },
      ]}
      fields={[
        { key: "nom_animal", label: "Nom de l'animal", span: 4, required: true },
        { key: "espece", label: "Espèce", type: "select", span: 4, options: Object.entries(ESPECES).map(([v, l]) => ({ value: v, label: l })) },
        { key: "race", label: "Race", span: 4 },
        { key: "proprietaire_nom", label: "Propriétaire", span: 6, required: true },
        { key: "proprietaire_telephone", label: "Téléphone", span: 6 },
        { key: "date_arrivee", label: "Date arrivée", type: "date", span: 4, required: true },
        { key: "date_depart_prevue", label: "Sortie prévue", type: "date", span: 4, required: true },
        { key: "prix_jour", label: "Prix/jour (€)", type: "number", step: "0.01", span: 4 },
        { key: "status", label: "Statut", type: "select", span: 12, options: Object.entries(STATUS).map(([v, l]) => ({ value: v, label: l })) },
        { key: "regime_alimentaire", label: "Régime alimentaire", type: "textarea", span: 6 },
        { key: "traitements", label: "Traitements / médicaments", type: "textarea", span: 6 },
        { key: "notes", label: "Notes", type: "textarea", span: 12 },
      ]}
      emptyIcon={PawPrint}
      emptyText="Aucun pensionnaire."
    />
  );
}
